var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomName(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.043 9.36c-.326.277-.64.472-.942.586-.3.114-.622.171-.967.171-.57 0-1.008-.138-1.314-.415a1.385 1.385 0 01-.459-1.07c0-.253.057-.484.171-.693a1.46 1.46 0 01.454-.507c.19-.127.4-.223.635-.288.173-.046.433-.09.781-.132.71-.085 1.232-.186 1.568-.303l.005-.23c0-.358-.083-.61-.25-.756-.224-.199-.558-.298-1-.298-.414 0-.72.073-.918.22-.196.143-.34.398-.435.766l-.86-.117c.079-.368.207-.664.386-.889.18-.228.438-.402.777-.522.338-.124.73-.186 1.177-.186.442 0 .802.052 1.079.157.276.104.48.236.61.395.13.156.221.355.273.596.03.15.044.42.044.81v1.172c0 .817.018 1.335.054 1.553.04.215.114.421.225.62h-.918a1.863 1.863 0 01-.176-.64zM5.97 7.397c-.32.13-.798.241-1.436.332-.361.053-.617.111-.766.176a.759.759 0 00-.47.703c0 .235.089.43.264.586.18.157.44.235.782.235.338 0 .64-.074.903-.22.264-.15.457-.353.581-.61.095-.199.142-.492.142-.88v-.322z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M8.5 0v15M7 .5h3M7 14.5h3M7 2.5H0M7 12.5H0M16 12.5h-6M16 2.5h-6M15.5 2v11M.5 2v11"
  })));
}

export default SvgCustomName;